
import React, { useState, useEffect } from "react";
import "antd/dist/antd.min.css";
import BackButton from "../../helpers/BackButton";
import { Breadcrumb, Layout, Menu, Typography, DatePicker } from "antd";
import { Space, Table, Tag, Button } from "antd";
import { Link, Route, Routes } from "react-router-dom";
import PageWrapper from "../../helpers/PageWrapper";
import streamService from '../../../services/streamService';
import { Input, Form, Select, InputNumber, message } from 'antd';
import moment from 'moment';
// import { LessonDtoRequest } from '../../interfaces/LessonDtoRequest';
import axios from 'axios';
import authAxios from "../../../services/api";
import { useParams } from 'react-router';
import { useForm } from "antd/es/form/Form";
import TokenService from "../../../services/token.service";
import { useNavigate } from 'react-router-dom';
const { Title } = Typography;
const styles = { width: '800px', margin: '0 auto' };

const LessonUpdatePage = () => {
  const { teacherId, streamId, id } = useParams();

  const [users, setUser] = useState([])
  const [date, setDate] = useState("");
  const [theme, setTheme] = useState("");
  const [desc, setDesc] = useState("");
  const [userId, setUserId] = useState(null)
  const [form] = useForm();
  const navigate = useNavigate();

  

  useEffect(() => {
    getUsers();
  }, [])
  function getUsers() {
    authAxios.get(`http://85.159.27.198:8080/abitur/api/v1/teacher/${teacherId}/streams/${streamId}/lessons/${id}`, {
      headers: {
          'Authorization': 'Bearer ' + TokenService.getLocalAccessToken(),
      }
  }).then((resp) => {
      console.log(resp)
        // console.warn(resp)
        setUser(resp.data)
        setDate(resp.data.date)
        setTheme(resp.data.theme)
        setDesc(resp.data.desc)
        setUserId(resp.data.id)
        form.setFieldsValue({
          theme: resp.data.theme,
          desc: resp.data.desc,
          date: resp.data.date
        })
        // console.log(resp.date)
      
    }).catch((error) =>  message.error(error, 10));
  }

  function updateUser() {
    let item = { date, theme, desc }
    console.warn("item", item)
    authAxios.put(`http://85.159.27.198:8080/abitur/api/v1/teacher/${teacherId}/streams/${streamId}/lessons/update?lessonId=${id}`, item,  {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + TokenService.getLocalAccessToken()
      },
      
    }).then((resp) => {
      
        console.warn(resp)
        getUsers()
      
      message.success('Урок обновлен', 10);
    navigate(`/lesson-plan-page/teacherId/${teacherId}/stream-id/${streamId}`);
    window.location.reload();
}).catch((error) =>  message.error(error, 10));
    
    
  }

  const onDateChange = (date, dateString) => {
    setDate(dateString)
  };


  return (
    <PageWrapper>
      {/* <BackButton link={"/lesson-plan-page"} /> */}
      <Typography.Title level={1}>Изменить урок</Typography.Title>
      <Form
        layout="vertical"
        size="large"
        style={styles}
        form={form}
        initialValues={{ remember: true }}
        autoComplete="off"
        onFinish={updateUser}
      >
        <Form.Item
          label="Дата занятия"
          name="date"
          initialValue={date}
          rules={[{ required: true, message: 'Выберите дату' }]}
        >

          {console.log()}
          <DatePicker allowClear={false} onChange={onDateChange} value={moment(date)} 
            format="YYYY-MM-DD"  />
        </Form.Item>
        <Form.Item
          label="Тема Занятия"
          name="theme"
          rules={[{ required: true, message: 'Введите тему занятия' }]}
        >
          <Input onChange={(e) => { setTheme(e.target.value) }} />
        </Form.Item>
        <Form.Item
          label="Домашняя работа"
          name="desc"
          onChange={(e) => { setDesc(e.target.value) }}
          rules={[
            {
              required: true,
              message: 'Введите домашнюю работу',
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item>
          <Space>
            <Button type="primary" htmlType="submit" >
              Сохранить
            </Button>

          </Space>
        </Form.Item>
      </Form>
    </PageWrapper>



  )
}


export default LessonUpdatePage;